import React from 'react';
export function Level3Detail() {
  const editables = [{
    icon: '📊',
    title: 'Planificador de Carrera'
  }, {
    icon: '📅',
    title: 'Calendario de Parciales'
  }, {
    icon: '📋',
    title: 'Planificador Semanal'
  }, {
    icon: '✅',
    title: 'Tracker de Temas'
  }, {
    icon: '🗓️',
    title: 'Calendario Anual 2025'
  }, {
    icon: '🗺️',
    title: 'Hoja de Ruta del Examen'
  }, {
    icon: '📝',
    title: 'Resumen Rápido de Materia'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-12 md:py-20 px-4 border-t-8 border-brand-amber" data-id="element-339">
      <div className="max-w-5xl mx-auto" data-id="element-340">
        <div className="text-center mb-12" data-id="element-341">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-amber mb-4 flex items-center justify-center gap-3" data-id="element-342">
            <span data-id="element-343">🏆</span> Sistema de Gestión Académica™
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-344">
            Todo el sistema más 7 editables premium para planificar, organizar y
            dominar cada materia de la carrera.
          </p>
        </div>

        <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 mb-12 max-w-3xl mx-auto" data-id="element-345">
          <div className="font-bold text-slate-800 mb-4 flex items-center gap-2" data-id="element-346">
            <span data-id="element-347">✅</span> Ya incluye todo el Sistema Carrera Organizada™
          </div>
          <div className="flex flex-wrap gap-4 text-sm font-medium text-slate-700" data-id="element-348">
            <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-md border border-amber-100" data-id="element-349">
              <span data-id="element-350">📚</span> 6 Tomos
            </div>
            <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-md border border-amber-100" data-id="element-351">
              <span data-id="element-352">🎁</span> 6 Bonos
            </div>
            <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-md border border-amber-100" data-id="element-353">
              <span data-id="element-354">🚨</span> Tomo 07
            </div>
            <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-md border border-amber-100" data-id="element-355">
              <span data-id="element-356">🩺</span> Tomo 08
            </div>
          </div>
        </div>

        <div className="mb-8 text-center flex items-center justify-center gap-3" data-id="element-357">
          <div className="font-bold text-slate-900 text-xl" data-id="element-358">
            ✏️ Lo nuevo: 7 Editables Premium
          </div>
          <div className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-359">
            EXCLUSIVO
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto mb-16" data-id="element-360">
          {editables.map((item, idx) => <div key={idx} className="bg-white rounded-xl p-4 border-2 border-slate-100 shadow-sm flex items-center gap-3 relative" data-id="element-361">
              <div className="text-2xl" data-id="element-362">{item.icon}</div>
              <div className="font-bold text-slate-800 text-sm" data-id="element-363">
                {item.title}
              </div>
              <div className="absolute -top-2 -right-2 bg-slate-200 text-slate-600 text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-364">
                editable
              </div>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-365">
          <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-366">
            🏆 Todo en un solo lugar — listo para usar desde el día uno
          </h3>
          <p className="text-lg text-slate-600 mb-8" data-id="element-367">
            La decisión más inteligente para avanzar en Medicina sin perder
            tiempo ni energía.
          </p>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-brand-amber hover:bg-amber-600 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-transform hover:scale-105 active:scale-95 min-h-[56px]" data-id="element-368">
            → VER PRECIOS Y OPCIONES
          </button>
        </div>
      </div>
    </section>;
}